var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "full-height slot-data" },
      [
        _c(
          "el-dialog",
          {
            attrs: {
              "custom-class": "position-data--edit",
              "append-to-body": "",
              title: !_vm.positionForm.id ? "建立版位" : "版位維護",
              visible: _vm.dialogFormVisible,
              width: "60%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogFormVisible = $event
              },
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "positionForm",
                attrs: { model: _vm.positionForm, size: "mini" },
                nativeOn: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "companyName", label: "產品名稱" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.positionForm.project,
                        callback: function ($$v) {
                          _vm.$set(_vm.positionForm, "project", $$v)
                        },
                        expression: "positionForm.project",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { prop: "advertisementName", label: "版位名稱" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.positionForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.positionForm, "name", $$v)
                        },
                        expression: "positionForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { prop: "quantityLimit", label: "數量上限" } },
                  [
                    _c("el-input", {
                      model: {
                        value: _vm.positionForm.quantityLimit,
                        callback: function ($$v) {
                          _vm.$set(_vm.positionForm, "quantityLimit", $$v)
                        },
                        expression: "positionForm.quantityLimit",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { prop: "status", label: "狀態" } },
                  [
                    _c("el-switch", {
                      attrs: {
                        "active-text": "啟用",
                        "inactive-text": "停用",
                        "inactive-color": "#ff4949",
                        "active-color": "#13ce66",
                        "active-value": true,
                        "inactive-value": false,
                      },
                      model: {
                        value: _vm.positionForm.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.positionForm, "status", $$v)
                        },
                        expression: "positionForm.status",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { prop: "type", label: "類型" } },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.positionForm.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.positionForm, "type", $$v)
                          },
                          expression: "positionForm.type",
                        },
                      },
                      [
                        _c("el-radio-button", { attrs: { label: 1 } }, [
                          _vm._v("付費"),
                        ]),
                        _c("el-radio-button", { attrs: { label: 2 } }, [
                          _vm._v("免費"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { color: "#4b4b4b" },
                    attrs: { type: "warning" },
                    on: { click: _vm.saveData },
                  },
                  [_vm._v("儲 存")]
                ),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function ($event) {
                        _vm.dialogFormVisible = false
                      },
                    },
                  },
                  [_vm._v("關 閉")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-form",
          {
            staticClass: "filter-form",
            attrs: { inline: true },
            nativeOn: {
              submit: function ($event) {
                $event.preventDefault()
              },
            },
          },
          [
            _c(
              "el-form-item",
              { attrs: { label: "查詢" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "輸入產品/版位名稱" },
                  nativeOn: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.getList($event)
                    },
                  },
                  model: {
                    value: _vm.listQuery.qry,
                    callback: function ($$v) {
                      _vm.$set(_vm.listQuery, "qry", $$v)
                    },
                    expression: "listQuery.qry",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "狀態" } },
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "請選擇狀態" },
                    on: { change: _vm.getList },
                    model: {
                      value: _vm.listQuery.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "status", $$v)
                      },
                      expression: "listQuery.status",
                    },
                  },
                  _vm._l(
                    [
                      { key: "", val: "所有" },
                      { key: 1, val: "啟用" },
                      { key: 0, val: "停用" },
                    ],
                    function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.val, value: item.key },
                      })
                    }
                  ),
                  1
                ),
              ],
              1
            ),
            _c("el-button", {
              staticStyle: { "margin-top": "8px", "margin-left": "5px" },
              attrs: {
                type: "primary",
                icon: "el-icon-search",
                circle: "",
                disabled: _vm.listLoading,
              },
              on: { click: _vm.getList },
            }),
            _c("el-button", {
              attrs: {
                type: "warning",
                circle: "",
                icon: "el-icon-plus",
                disabled: _vm.listLoading,
              },
              on: {
                click: function ($event) {
                  return _vm.editPositionData({ id: null })
                },
              },
            }),
            _c("el-button", {
              staticStyle: { cursor: "pointer" },
              attrs: {
                type: "success",
                loading: _vm.listLoading,
                circle: "",
                icon: "el-icon-refresh-left",
              },
              on: {
                click: function ($event) {
                  return _vm.refresh()
                },
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          {
            staticStyle: {
              position: "relative",
              height: "80%",
              display: "flex",
              gap: "0 8px",
            },
          },
          [
            _c(
              "div",
              { staticStyle: { height: "100%" } },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.listLoading,
                        expression: "listLoading",
                      },
                    ],
                    ref: "positionTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.list,
                      size: "mini",
                      border: "",
                      fit: "",
                      height: "100%",
                      "row-class-name": _vm.tableRowStatus,
                      "highlight-current-row": "",
                      "current-row-key": "id",
                      "row-key": "id",
                    },
                    on: {
                      "sort-change": _vm.sortChange,
                      "row-click": _vm.handleSelectPosition,
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "advertisementName",
                        label: "版位列表 ｜" + _vm.total,
                        width: "300",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticStyle: { cursor: "pointer" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "space-between",
                                        "align-items": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            gap: "0 8px",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "align-items": "center",
                                                gap: "0 8px",
                                                "min-width": "fit-content",
                                              },
                                            },
                                            [
                                              _c("div", {
                                                staticStyle: {
                                                  width: "6px",
                                                  height: "6px",
                                                  "border-radius": "50%",
                                                },
                                                style: {
                                                  background:
                                                    scope.row.status == 1
                                                      ? "#13ce66"
                                                      : "#ff4949",
                                                },
                                              }),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "letter-spacing": "0.05em",
                                                    "font-weight": "500",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row.status == 1
                                                          ? "啟用"
                                                          : "停用"
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                content: "進行中數量上限",
                                                placement: "right",
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "font-size": "12px",
                                                    color: "#868686",
                                                    "font-weight": "500",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.handleFormatProgress(
                                                          scope.row.adCount,
                                                          scope.row
                                                            .quantityLimit
                                                        )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        [
                                          _c("el-button", {
                                            attrs: {
                                              size: "small",
                                              circle: "",
                                              icon: "el-icon-edit",
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.editPositionData(
                                                  scope.row
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "font-weight": "500",
                                        "font-size": "14px",
                                        "letter-spacing": "0.05em",
                                        padding: "8px 0",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.project) +
                                          " - " +
                                          _vm._s(scope.row.name) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "align-items": "center",
                                        "border-top": "1px solid #ddd",
                                        "padding-top": "8px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            "justify-content": "center",
                                            "text-align": "center",
                                            width: "100%",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "min-width": "fit-content",
                                                padding: "0 8px",
                                                "border-radius": "5px",
                                              },
                                              style: {
                                                color: "#fff",
                                                backgroundColor:
                                                  scope.row.type == 1
                                                    ? "#fe4949"
                                                    : "#41b983",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.type == 1
                                                      ? "付費"
                                                      : "免費"
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            "justify-content": "center",
                                            "text-align": "center",
                                            width: "100%",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-weight": "900",
                                                "font-size": "16px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.adCount
                                                      .preparing || 0
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c("div", [_vm._v("未開始")]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            "justify-content": "center",
                                            "text-align": "center",
                                            width: "100%",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-weight": "900",
                                                "font-size": "16px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.adCount
                                                      .processing || 0
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c("div", [_vm._v("進行中")]),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-direction": "column",
                                            "justify-content": "center",
                                            "text-align": "center",
                                            width: "100%",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "font-weight": "900",
                                                "font-size": "16px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    scope.row.adCount.isOver ||
                                                      0
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c("div", [_vm._v("已結束")]),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    false
                      ? _c("el-table-column", {
                          attrs: {
                            prop: "advertisementName",
                            label: "版位列表 ｜" + _vm.total,
                            width: "300",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          cursor: "pointer",
                                          padding: "6px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "justify-content":
                                                "space-between",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "align-items": "center",
                                                  gap: "0 8px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      "align-items": "center",
                                                      gap: "0 8px",
                                                      "min-width":
                                                        "fit-content",
                                                    },
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticStyle: {
                                                        width: "6px",
                                                        height: "6px",
                                                        "border-radius": "50%",
                                                      },
                                                      style: {
                                                        background:
                                                          scope.row.status == 1
                                                            ? "#13ce66"
                                                            : "#ff4949",
                                                      },
                                                    }),
                                                    _c(
                                                      "p",
                                                      {
                                                        staticStyle: {
                                                          "letter-spacing":
                                                            "0.05em",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              scope.row
                                                                .status == 1
                                                                ? "啟用"
                                                                : "停用"
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" ｜ "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      "font-size": "12px",
                                                      color: "#868686",
                                                      "font-weight": "500",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "上限：" +
                                                        _vm._s(
                                                          _vm.handleFormatProgress(
                                                            scope.row.adCount,
                                                            scope.row
                                                              .quantityLimit
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              [
                                                _c("el-button", {
                                                  attrs: {
                                                    size: "small",
                                                    circle: "",
                                                    icon: "el-icon-edit",
                                                  },
                                                  nativeOn: {
                                                    click: function ($event) {
                                                      return _vm.editPositionData(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "font-weight": "500",
                                              "font-size": "14px",
                                              "letter-spacing": "0.05em",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row.project) +
                                                " - " +
                                                _vm._s(scope.row.name) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "flex-direction": "column",
                                                  "justify-content": "center",
                                                  "text-align": "center",
                                                  width: "100%",
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-tag",
                                                  {
                                                    staticStyle: {
                                                      "min-width":
                                                        "fit-content",
                                                    },
                                                    attrs: {
                                                      type:
                                                        scope.row.type == 1
                                                          ? "danger"
                                                          : "success",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.type == 1
                                                          ? "付費"
                                                          : "免費"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "flex-direction": "column",
                                                  "justify-content": "center",
                                                  "text-align": "center",
                                                  width: "100%",
                                                },
                                              },
                                              [
                                                _c("div", [_vm._v("3")]),
                                                _c("div", [_vm._v("未開始")]),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "flex-direction": "column",
                                                  "justify-content": "center",
                                                  "text-align": "center",
                                                  width: "100%",
                                                },
                                              },
                                              [
                                                _c("div", [_vm._v("3")]),
                                                _c("div", [_vm._v("進行中")]),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "flex-direction": "column",
                                                  "justify-content": "center",
                                                  "text-align": "center",
                                                  width: "100%",
                                                },
                                              },
                                              [
                                                _c("div", [_vm._v("3")]),
                                                _c("div", [_vm._v("已結束")]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            244786657
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                staticStyle: {
                  height: "100%",
                  flex: "1",
                  "max-width": "100%",
                  "overflow-x": "auto",
                },
              },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.contentLoading,
                        expression: "contentLoading",
                      },
                    ],
                    attrs: {
                      size: "mini",
                      data: _vm.selectedPosition,
                      border: "",
                      fit: "",
                      height: "100%",
                      "row-key": "id",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { align: "center", label: "項次", width: "50" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(" " + _vm._s(scope.$index + 1) + " "),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "封面圖" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              !!scope.row.mapping &&
                              !!scope.row.mapping.fileInfo
                                ? _c("img", {
                                    staticStyle: {
                                      height: "80px",
                                      width: "100%",
                                      "object-fit": "contain",
                                    },
                                    attrs: {
                                      src: scope.row.mapping.fileInfo.url,
                                    },
                                  })
                                : _c("el-image", {
                                    staticStyle: { height: "80px" },
                                    attrs: {
                                      src: "https://fakeimg.pl/280x160/",
                                      fit: "contain",
                                      "preview-src-list": [
                                        "https://fakeimg.pl/280x160/",
                                      ],
                                      lazy: true,
                                    },
                                  }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "廣告名稱", prop: "advertisementName" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "right",
                                    width: "400",
                                    trigger: "hover",
                                  },
                                },
                                [
                                  _c(
                                    "el-descriptions",
                                    {
                                      staticClass: "margin-top",
                                      attrs: {
                                        title: "廣告詳情",
                                        column: 1,
                                        size: "small",
                                        border: "",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-descriptions-item",
                                        [
                                          _c("template", { slot: "label" }, [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-office-building",
                                            }),
                                            _vm._v(" 廣告名稱 "),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "clipboard",
                                                  rawName: "v-clipboard:copy",
                                                  value: row.advertisementName,
                                                  expression:
                                                    "row.advertisementName",
                                                  arg: "copy",
                                                },
                                                {
                                                  name: "clipboard",
                                                  rawName:
                                                    "v-clipboard:success",
                                                  value: _vm.clipboardSuccess,
                                                  expression:
                                                    "clipboardSuccess",
                                                  arg: "success",
                                                },
                                              ],
                                              staticClass: "copy-container",
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      row.advertisementName
                                                    ) +
                                                    " "
                                                ),
                                              ]),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        !!row.advertisementName,
                                                      expression:
                                                        "!!row.advertisementName",
                                                    },
                                                  ],
                                                  staticClass: "copy-icon",
                                                },
                                                [
                                                  _c("el-icon", {
                                                    attrs: {
                                                      name: "document-copy",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "el-descriptions-item",
                                        [
                                          _c("template", { slot: "label" }, [
                                            _c("i", {
                                              staticClass: "el-icon-tickets",
                                            }),
                                            _vm._v(" 排序 "),
                                          ]),
                                          _c("div", [
                                            _vm._v(
                                              " " +
                                                _vm._s(row.mapping.priority) +
                                                " "
                                            ),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "el-descriptions-item",
                                        [
                                          _c("template", { slot: "label" }, [
                                            _c("i", {
                                              staticClass: "el-icon-time",
                                            }),
                                            _vm._v(" 廣告期間 "),
                                          ]),
                                          _c(
                                            "el-tag",
                                            { attrs: { size: "small" } },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.startDate +
                                                      " 至 " +
                                                      row.endDate
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                      _c(
                                        "el-descriptions-item",
                                        [
                                          _c("template", { slot: "label" }, [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-location-outline",
                                            }),
                                            _vm._v(" 網址 "),
                                          ]),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "clipboard",
                                                  rawName: "v-clipboard:copy",
                                                  value: row.mapping.link,
                                                  expression:
                                                    "row.mapping.link",
                                                  arg: "copy",
                                                },
                                                {
                                                  name: "clipboard",
                                                  rawName:
                                                    "v-clipboard:success",
                                                  value: _vm.clipboardSuccess,
                                                  expression:
                                                    "clipboardSuccess",
                                                  arg: "success",
                                                },
                                              ],
                                              staticClass: "copy-container",
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticStyle: {
                                                    color: "#1890ff",
                                                  },
                                                  attrs: {
                                                    href: row.mapping.link,
                                                    target: "_blank",
                                                  },
                                                  on: {
                                                    "!click": function (
                                                      $event
                                                    ) {},
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(row.mapping.link)
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value: !!row.mapping.link,
                                                      expression:
                                                        "!!row.mapping.link",
                                                    },
                                                  ],
                                                  staticClass: "copy-icon",
                                                },
                                                [
                                                  _c("el-icon", {
                                                    attrs: {
                                                      name: "document-copy",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        cursor: "pointer",
                                        hover: "opacity:75%",
                                      },
                                      attrs: { slot: "reference" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.toggleExpand(row)
                                        },
                                      },
                                      slot: "reference",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "text-decoration": "underline",
                                            "font-weight": "500",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(row.advertisementName) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c("br"),
                                      _c(
                                        "span",
                                        { staticStyle: { color: "#939393" } },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(row.startDate) +
                                              " 至 " +
                                              _vm._s(row.endDate) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "排序", width: "60" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.mapping
                                ? _c("p", [
                                    _vm._v(
                                      " " +
                                        _vm._s(scope.row.mapping.priority) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { align: "center", label: "曝光數", width: "60" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.mapping
                                ? _c("p", [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          (
                                            scope.row.mapping.showCount || 0
                                          ).toLocaleString()
                                        ) +
                                        " "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: "狀態",
                        width: "100",
                        fixed: "right",
                        filters: [
                          { text: "未開始", value: "未開始" },
                          { text: "進行中", value: "進行中" },
                          { text: "已結束", value: "已結束" },
                        ],
                        "filter-method": _vm.filterStatus,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    size: "small",
                                    type: _vm.handleStatus(
                                      scope.row.startDate,
                                      scope.row.endDate
                                    ).type,
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.handleStatus(
                                          scope.row.startDate,
                                          scope.row.endDate
                                        ).text
                                      )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: "公司名稱",
                        prop: "companyName",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "a",
                                {
                                  staticStyle: { color: "#20a0ff" },
                                  attrs: {
                                    href:
                                      "/advertisement/customerCompany?q=" +
                                      scope.row.companyName,
                                    target: "_blank",
                                  },
                                },
                                [_vm._v(" " + _vm._s(scope.row.companyName))]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        align: "center",
                        label: "操作",
                        width: "100",
                        fixed: "right",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "danger", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delePositionData(
                                        scope.row.mapping
                                      )
                                    },
                                  },
                                },
                                [_vm._v("刪除")]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
        _c("pagination", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.total > 0,
              expression: "total > 0",
            },
          ],
          attrs: {
            layout: "prev, pager, next",
            total: _vm.total,
            page: _vm.listQuery.page,
            limit: _vm.listQuery.limit,
          },
          on: {
            "update:page": function ($event) {
              return _vm.$set(_vm.listQuery, "page", $event)
            },
            "update:limit": function ($event) {
              return _vm.$set(_vm.listQuery, "limit", $event)
            },
            pagination: _vm.getList,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }